__turbopack_context__.v({
  "buttonContent": "BuildTripButton-module__O4Gkva__buttonContent",
  "buttonText": "BuildTripButton-module__O4Gkva__buttonText",
  "closeButton": "BuildTripButton-module__O4Gkva__closeButton",
  "desktop": "BuildTripButton-module__O4Gkva__desktop",
  "headerRow": "BuildTripButton-module__O4Gkva__headerRow",
  "heroCtaButtonContent": "BuildTripButton-module__O4Gkva__heroCtaButtonContent",
  "mobile": "BuildTripButton-module__O4Gkva__mobile",
  "oldBuildTripButton": "BuildTripButton-module__O4Gkva__oldBuildTripButton",
  "title": "BuildTripButton-module__O4Gkva__title",
});
